import { useThemeContext } from '#contexts/ThemeContext';
import { LoadingTheme } from './LoadingTheme';

export const LoadingDiv = ({ open = false }: { open: boolean }) => {
  const { primaryButtonBackground } = useThemeContext();
  return <LoadingTheme open={open} primaryButtonBackground={primaryButtonBackground} />;
};
